import { Fragment, PropsWithChildren, useEffect, useState } from "react";
import { isAuthenticated } from "services/Auth";
import { useDispatch } from "react-redux";
import { showAuthModal } from "store/application/application-action";

const WithAuthRequired = ({ children }: PropsWithChildren) => {
  const dispatch = useDispatch();
  const [isAuth, setIsAuth] = useState(false);

  useEffect(() => {
    (async () => {
      (await isAuthenticated()) ? setIsAuth(true) : dispatch(showAuthModal());
    })();
  }, [dispatch]);

  return isAuth ? <Fragment>{children}</Fragment> : null;
};

export default WithAuthRequired;
